import types from "./types";
import initialState from "./initialState";

export default (state = initialState, action) => {
  switch (action.type) {
    case types.GET_PROJECTS_STATS:
      return { ...state, ...{ fetching: true } };
    case types.GET_PROJECTS_STATS_SUCCESS:
      return {
        ...state,
        ...{
          data: action.payload,
          fetching: false,
          error: null
        }
      };
    case types.GET_PROJECTS_STATS_ERROR:
      return { ...state, ...{ error: action.payload } };
    case types.SET_SELECTED_WARD:
      return { ...state, selectedWard: action.payload };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/infraMonitor/projects-stats/reducers.js